import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Sexo } from '@/modules/escritorio/types/enums/Genero.enum';
import { TipoUsuarioPerfilOpcionEnum } from '@/modules/escritorio/types/enums/TipoUsuario.enum';
import type { InfoUser } from '@/modules/escritorio/types/interfaces/escritorio';
import defaultUserIcon from '@/assets/icon/icon-user.svg';

/**
 * Hook personalizado para obtener y formatear los datos del usuario autenticado
 */
export const useUserData = () => {
  const { state } = useAuth();
  const { user, isAuthenticated } = state;

  /**
   * Extrae el exequatur del usuario (para abogados)
  */
 const getExequatur = (): string => {
    //TODO: Validar porqué en algunos casos no está la matrícula cuando es abogado
    if (user?.matricula) {
      return user.matricula;
    }

    return '';
  };

  /**
   * Datos del usuario formateados
   */
  const userData: InfoUser | null = useMemo(() => {
    if (!isAuthenticated || !user) {
      return null;
    }

    // const genero = getUserGender(user.idSexo);
    const tipoUsuario = user.idPerfil as TipoUsuarioPerfilOpcionEnum;
    const exequatur = getExequatur();

    return {
      id: user.id ? parseInt(user.id) : 0,
      idPerfil: user.idPerfil,
      fullName: user.fullName || 'Usuario',
      genero: user.genero || '',      
      tipoUsuario,
      image: user.imageUrl || defaultUserIcon,
      validado: true, // <-- Por defecto, si el usuario está autenticado, está validado
      exequatur: tipoUsuario === TipoUsuarioPerfilOpcionEnum.ENTIDAD ? exequatur : '',
      rnc: user?.rnc || '',
      identificacion: user?.identificacion || '',
      telefono: user?.telefono || '',
      email: user?.email || '',
      idSexo: user?.idSexo as Sexo,
      matricula: user?.matricula || '',
      fechaEmisionCarnet: user?.fechaEmisionCarnet || '',
      esPrimerInicioSesion: user?.esPrimerInicioSesion || false,
      esActivo2FA: user?.esActivo2FA || false,
    };
  }, [user, isAuthenticated]);

  /**
   * Estado de carga
   */
  const isLoading = state.isLoading;

  /**
   * Refrescar/actualizar los datos del usuario
   */
  const refreshUserData = () => {
    //TODO: Esta función podría disparar una actualización del contexto si es necesario
  };

  return {
    userData,
    isLoading,
    isAuthenticated,
    refreshUserData,
    image: userData?.image || defaultUserIcon,
    fullName: userData?.fullName || 'Usuario',
    userType: userData?.tipoUsuario,
    gender: userData?.genero,
    isValidated: userData?.validado || false,
    userImage: userData?.image || defaultUserIcon,
    exequatur: userData?.exequatur,
    rnc: userData?.rnc,
    identificacion: userData?.identificacion, 
    telefono: userData?.telefono,
    email: userData?.email,
    idSexo: userData?.idSexo,
    esActivo2FA: user?.esActivo2FA || false,
    esPrimerInicioSesion: user?.esPrimerInicioSesion || false,
    systemTime: user?.systemTime,
  };
};